/* eslint-disable no-console */
var MessagePrefix;

(function (MessagePrefix) {
  MessagePrefix["accessibility"] = "Flora Accessibility";
  MessagePrefix["development"] = "Flora Development";
})(MessagePrefix || (MessagePrefix = {}));

var log = _ref => {
  var {
    category,
    status = 'info',
    message
  } = _ref;
  console[status](MessagePrefix[category] + " (" + [status] + "): " + message);
};

var exception = _ref2 => {
  var {
    category,
    message
  } = _ref2;
  throw new Error(MessagePrefix[category] + " (error): " + message);
};

export var floraMessage = _ref3 => {
  var {
    category,
    type,
    status,
    message
  } = _ref3;

  if (type === 'log') {
    log({
      category,
      status,
      message
    });
  }

  if (type === 'exception') {
    exception({
      category,
      message
    });
  }
};
//# sourceMappingURL=messages.js.map